import React from "react"
import Back from "../common/back/Back"
import "./contact.css"

const Contact = () => {
  // embed your exact WELSH EDUCATION GROUP location by its coordinates
  const map = "https://maps.google.com/maps?q=30.210225,74.945490&z=21&output=embed"

  return (
    <>
      <Back title="Contact us" />
      <section className="contacts padding">
        <div className="container shadow flexSB">
          <div className="left row">
            <iframe
              src={map}
              title="location map"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </div>
          <div className="right row">
            <h1>Contact us</h1>
            <p>We're open for any suggestion or just to have a chat</p>

            <div className="items grid2">
              <div className="box">
                <h4>ADDRESS:</h4>
                <p>Bathinda, Punjab</p>
              </div>
              <div className="box">
                <h4>CALL US:</h4>
                <p>8048026985</p>
              </div>
              <div className="box">
                <h4>EMAIL:</h4>
                <p>info@welshvisaglobal.co.in</p>
              </div>
              <div className="box">
                <h4>WHATSAPP:</h4>
                <p>
                  <a
                    href="https://wa.me/8048026985"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Chat Support
                  </a>
                </p>
              </div>
            </div>

            <form action="">
              <div className="flexSB">
                <input type="text" placeholder="Name" />
                <input type="email" placeholder="Email" />
              </div>
              <input type="text" placeholder="Subject" />
              <textarea
                cols="30"
                rows="10"
                placeholder="Create a message here..."
              ></textarea>
              <button className="primary-btn">SEND MESSAGE</button>
            </form>

            <h3>Follow us here</h3>
            <span>FACEBOOK TWITTER INSTAGRAM DRIBBBLE</span>
          </div>
        </div>
      </section>
    </>
  )
}

export default Contact
